// extracted by mini-css-extract-plugin
module.exports = {"root":"Qgy74ruo","horizonItem":"_GVJMokC"};